/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalForm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import Gotoform01 from 'DesignSystem/Svgs/Gotoform01/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MedicalForm({
  children,
  viewPath = "/App/Widget/Content/Questions/GreyfinchComplete/NextAction/MedicalForm",
  goTo
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="MedicalForm.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceL}
 marginBottom={dtSpaceM}
 text="Just one more thing..."
 textAlign="center"
/>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="MedicalForm.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 height={340}
 marginTopText={30}
 text="Complete Patient's Medical Form"
 width={340}
>
{childProps => (
<Gotoform01
{...childProps}
  viewPath={`${viewPath}/Gotoform01`}
 height={240}
 width={340}
/>
)}
</ButtonIconSquare>
</a>
</div>
{children}
</React.Fragment>)
}